<div class="toast-msg-conatiner" *ngIf="showToast">
    <div class="toast-msg" [style.backgroundColor]="isSuccess ? '#73d76a' : '#f54b4b'">
        {{notificationMsg}}
    </div>
</div>

<div class="modal fade show px-1" style="display: block; background: #00000030;">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ isEditMode ? 'Edit Category' : 'Add Category' }}</h5>
                <button (click)="closeModel.emit()" type="button" class="close">
                    <span>×</span>
                </button>
            </div>
            <form [formGroup]="categoryForm" (ngSubmit)="addOrUpdateCategory()">
                <div class="modal-body">
                    <div class="">
                        <div class="name">
                            <div class="label">Category name</div>
                            <input formControlName="name" type="text" class="input-field" autofocus>
                        </div>
                        <div *ngIf="categoryForm.get('name')?.touched && categoryForm.get('name')?.errors"
                            class="invalid-field"> Category name required</div>
                    </div>
                    <div class="">
                        <div class="name">
                            <div class="label">Sort Order</div>
                            <input formControlName="sortOrder" type="number" class="input-field" autofocus>
                        </div>
                    </div>
                    <div class="form-group mb-3" style="width: 100%; max-width: 400px;">
                        <div class="label pt-2">Category Image/Icon</div>
                        <div *ngIf="categoryForm?.get('categoryImage')?.value; else uploadPlaceholder"
                            class="category-image-section d-flex flex-column align-items-center justify-content-center position-relative">
                            <img [src]="categoryForm?.get('categoryImage')?.value" alt="Uploaded Logo"
                                style="max-width: 100%; max-height: 100%; object-fit: contain;" />
                            <div class="remove-button-container d-flex justify-content-center">
                                <button class="btn btn-outline-danger d-flex align-items-center py-1 px-3"
                                    (click)="clearFileUploader('categoryImage')" type="button">
                                    <i class="bi bi-x-lg me-1"></i> Remove
                                </button>
                            </div>
                        </div>
                        <ng-template #uploadPlaceholder>
                            <div (click)="fileInput.click()"
                                class="category-image-upload-section d-flex justify-content-center align-items-center">
                                + Click to select Image
                            </div>
                            <input type="file" id="fileInput" #fileInput accept="image/*" (change)="uploadFile($event)"
                                hidden />
                        </ng-template>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="row w-100 px-1">
                        <div class="col-12 px-1">
                            <button type="submit" class="save-btn w-100">
                                {{ isEditMode ? 'Update' : 'Create' }}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>